import { BrandEnvService }  from './services/brand-env.service';
import { LiveChat } from './live-chat';

(function() {

    if (!window.__liveChat) {
        var LiveChatConfigLoader = (function() {
            var config = {};
            var fn;
            var xmlhttp = new XMLHttpRequest();
            var url = BrandEnvService.getConfigUrl();
            xmlhttp.onreadystatechange = function() {
                if (this.readyState === 4 && this.status === 200) {
                    config = JSON.parse(this.responseText)[BrandEnvService.getEnvCode()];
                    if (fn) fn(config);
                }
            };
            xmlhttp.open('GET', url, true);
            xmlhttp.send();
            return {
                load: function(cb) {
                    if (Object.keys(config).length) cb(config);
                    else fn = cb;
                }
            };
        })();

        window.__liveChat = (function() {
            var instance, fn;
            LiveChatConfigLoader.load(function(config) {
                instance = new LiveChat(
                    config.accountId,
                    config.websiteId,
                    config.buttonIdMapping,
                    config.creditOpsRedirectionExcluded
                );
                if (fn) fn(instance);
            });
            return {
                getInstance: function(cb) {
                    if (instance) cb(instance);
                    else fn = cb;
                }
            };
        })();
    }
})();
